var scope_0 = require('/codebuild/output/src188244480/src/ceres/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6a1ab593c2a716abfa4ff1118befd681.js').default;
var scope_1 = require('/codebuild/output/src188244480/src/ceres/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    